import React from 'react';
import PropTypes from 'prop-types';
import { Typography } from '@mui/material';
import { resolveRunActor } from 'redux/slices/pipelines/helpers/resolveRunActor';

// deploy-pipelines-run-provenance (Wave 2) AC-2/AC-3/AC-4/AC-4a/AC-5/AC-14/AC-15 — the run console's
// "triggered by" line. Retires exactly one clause of Wave 1's AC-25 (the "triggered by" pin); every
// other clause stays in force.
//
// AC-5 / the developer-portal-log-output-xss precedent: TriggeredByUserName and TriggeredByEmail are
// user-controlled strings (they come from the triggering user's own account fields), so they render as
// TEXT NODES via Typography — never `dangerouslySetInnerHTML`, which appears nowhere in this slice.
//
// AC-14: `run.CreatedBy` is never read for display here, in ANY branch — not as text, not as a
// `title`, not as an `aria-label`. `resolveRunActor` does not even return it.
//
// AC-3 vs AC-4/AC-4a: "System" and "Unknown" are deliberately different words, so the two causes are
// visibly distinct (TC-DPRP-005 Step 5 / TC-DPRP-007 Step 5) rather than collapsed into one blank.
// Both are NORMAL, expected, permanent states — rendered in text.secondary like the surrounding meta,
// with no error colour, no warning icon, no spinner, no retry affordance and no "resolving…" copy
// (TC-DPRP-007 Steps 2/3). Nothing here implies the value will ever resolve later: it cannot (F1b).
const ACTOR_LABEL = {
	system: 'System',
	unknown: 'Unknown'
};

const RunTriggeredBy = ({ run }) => {
	const actor = resolveRunActor(run);
	const label = actor.kind === 'named' ? actor.name : ACTOR_LABEL[actor.kind];

	return (
		<Typography variant="body2" color="text.secondary">
			Triggered by{' '}
			{/* The email is supplementary ONLY — it annotates a name that was already resolved, and is
			    never a precondition for rendering the name (TC-DPRP-009), never reformatted, and never
			    a source for constructing one (AC-15). Attached only in the 'named' branch so it can
			    never sit on a System/Unknown line as a de-facto identity. */}
			<Typography component="span" variant="body2" color="text.primary" title={actor.kind === 'named' ? actor.email ?? undefined : undefined}>
				{label}
			</Typography>
		</Typography>
	);
};

export default React.memo(RunTriggeredBy);

RunTriggeredBy.propTypes = {
	run: PropTypes.shape({
		CreatedBy: PropTypes.string,
		TriggeredByUserName: PropTypes.string,
		TriggeredByEmail: PropTypes.string
	})
};
